// Generated by Melange

import * as Buhta_landing__DocsKassa from "./DocsKassa.js";
import * as Buhta_landing__DocsPost from "./DocsPost.js";
import * as Buhta_landing__DocsPosts from "./DocsPosts.js";
import * as Buhta_landing__DocsSidebar from "./DocsSidebar.js";
import * as Buhta_landing__DocsTopbar from "./DocsTopbar.js";
import * as Buhta_landing__Route from "../../Route.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function DocsSite(Props) {
  const currentRoute = Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined));
  let tmp;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Docs */ 1) {
    tmp = "sup";
  } else {
    switch (currentRoute._2) {
      case /* Home */ 0 :
        tmp = JsxRuntime.jsx(Buhta_landing__DocsPosts.make, {});
        break;
      case /* Kassa */ 1 :
        tmp = JsxRuntime.jsx(Buhta_landing__DocsKassa.make, {});
        break;
      case /* Post */ 2 :
        tmp = JsxRuntime.jsx(Buhta_landing__DocsPost.make, {});
        break;
    }
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Buhta_landing__DocsSidebar.make, {}),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_landing__DocsTopbar.make, {}),
          JsxRuntime.jsx("div", {
            children: tmp,
            className: "lg:w-217 m-auto px-6 lg:px-0 flex flex-col justify-between grow"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("hr", {
                className: "text-divider mt-10 lg:w-217 m-auto"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "buhta",
                    src: StaticAsset.src("/static/icons/question-16.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Вопросы? Задайте их",
                    className: "paragraph-small text-gray-landing ml-2"
                  }),
                  JsxRuntime.jsx("img", {
                    className: "ml-6",
                    alt: "buhta",
                    src: StaticAsset.src("/static/icons/at-16.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Контакты",
                    className: "paragraph-small text-gray-landing ml-2"
                  })
                ],
                className: "py-8 flex items-center px-6 lg:px-0 lg:w-217 m-auto"
              })
            ]
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                src: StaticAsset.src("/static/icons/location.svg")
              }),
              JsxRuntime.jsx("p", {
                children: "Казахстан",
                className: "caption-medium text-primary ml-1"
              }),
              JsxRuntime.jsx("img", {
                className: "ml-4",
                src: StaticAsset.src("/static/icons/language.svg")
              }),
              JsxRuntime.jsx("p", {
                children: "Русский",
                className: "caption-medium text-primary ml-1"
              })
            ],
            className: "lg:hidden bg-bg p-6 flex items-center"
          })
        ],
        className: "grow min-h-screen flex flex-col"
      })
    ],
    className: "flex font-haas flex-col lg:flex-row"
  });
}

const make = DocsSite;

export {
  make,
}
/* Buhta_landing__DocsKassa Not a pure module */
